<template>
  <Layout>
    <div v-if="stats.length" class="row">
      <div v-for="stat of stats" :key="stat.icon" :class="stat.wrapperClass">
        <Stat v-bind="stat" :loading="busy" />
      </div>
    </div>
    <div v-if="!lodash.isEmpty(filterColumns)">
      <model-filter v-model="filter" :columns="filterColumns" :modelVariable="modelVariable"
        :filterHandler="filterHandler" />
    </div>

    <div class="title">{{ lodash.upperCase($t('List')) }} {{ lodash.upperCase(title) }}</div>
    <b-card>
      <div class="row mb-2">
        <div class="col-sm-12 col-md-6">
          <div class="font-size-600 text-neutral-300">
            {{ cardTitle }}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-12 col-md-6">
          <div class="d-flex flex-wrap align-items-center gap-2">
            <b-button
                v-if="!denyCreate"
                
                size="lg"
                variant="primary"
                @click="handleCreate"
            >
              {{ $t("Create New") }}
            </b-button>
            <b-button
              :disabled="isAnyBulkActionLoading || !hasSelectedPurchasePlans"
              
              size="lg"
              variant="success"
              @click="handleBulkApprove"
            >
              <i v-if="bulkApproveLoading" class="bx bx-loader bx-spin"></i>
              {{ lodash.startCase($t('purchase_plans.buttons.approve')) }}
            </b-button>
            <b-button
                :disabled="isAnyBulkActionLoading || !hasSelectedPurchasePlans"
                
                size="lg"
                variant="danger"
                @click="handleBulkReject"
            >
              <i v-if="bulkRejectLoading" class="bx bx-loader bx-spin"></i>
              {{ lodash.startCase($t('purchase_plans.buttons.reject')) }}
            </b-button>
          </div>
        </div>
        <div class="d-flex col-12 col-md-6 justify-content-md-end align-items-center gap-2">
          <div class="flex-shrink-0 me-2">
            <table-model-button-group v-model="mode" @click="() => { this.$refs.table.$refs.table.refresh(); }" />
          </div>
          <div class="flex-shrink-0 me-2">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center mb-0">
                <b-form-select v-model="perPage" :options="[10, 50, 100, 250, 1000]" class="form-select-sm" size="sm" style="min-width: 75px;"
                  @change="$emit('update:perPage', $event)"></b-form-select>&nbsp;
              </label>
            </div>
          </div>
          <div class="flex-grow-1">
            <div id="tickets-table_filter" class="dataTables_filter text-md-end">
              <div class="prefix-icon">
                <svg fill="none" height="15" viewBox="0 0 15 15" width="15" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.8374 10.7933L15 13.9552L13.9552 15L10.7933 11.8374C9.61682 12.7805 8.15349 13.2935 6.64566 13.2913C2.97726 13.2913 0 10.3141 0 6.64566C0 2.97726 2.97726 0 6.64566 0C10.3141 0 13.2913 2.97726 13.2913 6.64566C13.2935 8.15349 12.7805 9.61682 11.8374 10.7933ZM10.3562 10.2454C11.2933 9.28169 11.8166 7.98988 11.8145 6.64566C11.8145 3.7895 9.50108 1.47681 6.64566 1.47681C3.7895 1.47681 1.47681 3.7895 1.47681 6.64566C1.47681 9.50108 3.7895 11.8145 6.64566 11.8145C7.98988 11.8166 9.28169 11.2933 10.2454 10.3562L10.3562 10.2454Z"
                    fill="#7E889D" />
                </svg>
              </div>

              <label class="d-inline-flex align-items-center w-100 mb-0">
                <b-form-input :debounce="500" :placeholder="$t('Pencarian') + '...'" :value="searchInput"
                  class="form-control form-control-sm ms-2" type="search" @input="onSearchInput"></b-form-input>
              </label>
            </div>
          </div>
        </div>
      </div>

      <model-index ref="table" class="col-12 purchase-plan-table" :loading="loading" v-bind="$props" :columns="columns" :busy.sync="busy"
        :models-paginated="modelsPaginated" :page.sync="page" :per-page.sync="perPage" :from="from"
        :total="totalFiltered" :search.sync="search" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
        :filter-params.sync="filterParams" @create-click="handleCreate" @export-click="handleExport"
        @show-click="handleShow" @edit-click="handleEdit" @delete-click="handleDelete" hide-table-header
        :deny-create="true"
        :card-attrs="{
          bodyClass: 'p-0 shadow',
          style: 'border: 1px solid #F1F5F9;border-radius: 10px;overflow: hidden;',
          class: 'border-0'
        }"
        >
        <template #card-tools>
          <div class="d-flex align-items-center justify-content-between gap-2 font-size-14 p-2">
            <div>
              <span style="font-weight: 400;" v-if="selectedPurchasePlanIds.length">{{ selectedPurchasePlanIds.length }} Terpilih</span>
            </div>
            <div>
              <b-link @click="selectAllSelectablePlans" class="btn-link text-primary font-weight-bold p-0 me-2">Pilih Semua ({{ totalSelectablePlansCount }})</b-link>
              <b-link @click="clearSelectedPurchasePlans" class="btn-link text-danger font-weight-bold p-0" v-if="selectedPurchasePlanIds.length">Batalkan Pilihan</b-link>
            </div>
          </div>
        </template>
        <template #action="{ data }">
          <b-dropdown-item v-if="!data.item['_denyShow']" @click="handleShow(data.item)">
            <i class="bx bx-show font-size-16 align-middle me-1 pb-1"></i>
            {{ $t("Detail") }}
          </b-dropdown-item>
          <b-dropdown-item v-if="!denyCreate" @click="handleDuplicate(data.item)">
            <i class="bx bx-copy-alt font-size-16 align-middle me-1 pb-1"></i>
            {{ lodash.startCase($t('purchase_plans.buttons.duplicate')) }}
          </b-dropdown-item>
          <b-dropdown-item v-if="!data.item['_denyCancel']" @click="handleCancel(data.item)">
            <i class="bx bx-x font-size-16 align-middle me-1 pb-1"></i>
            <span class="">Batalkan</span>
          </b-dropdown-item>
          <b-dropdown-item v-if="!data.item['_denyEdit']" @click="handleEdit(data.item)">
            <i class="bx bx-edit font-size-16 align-middle me-1 pb-1"></i>
            {{ $t("Edit") }}
          </b-dropdown-item>
          <b-dropdown-item v-if="!data.item['_denyDelete']" @click="handleDelete(data.item)">
            <i class="bx bx-trash font-size-16 align-middle me-1 pb-1"></i>
            <span class="">{{ $t("Delete") }}</span>
          </b-dropdown-item>
        </template>
      </model-index>
    </b-card>

    <purchase-plan-approve-confirmation
        ref="purchase-plan-approve-confirmation"
    />
    <purchase-plan-reject-confirmation
        ref="purchase-plan-reject-confirmation"
    />
    <purchase-plan-bulk-action-success
        ref="purchase-plan-bulk-action-success"
        @hidden="handleBulkActionResultModalHidden"
    />
    <purchase-plan-bulk-action-partial-success
        ref="purchase-plan-bulk-action-partial-success"
        @hidden="handleBulkActionResultModalHidden"
    />

    <purchase-plan-duplicate-confirmation
        ref="duplicateConfirmation"
    />
    <purchase-plan-cancel-confirmation
        ref="cancelConfirmation"
        @cancelled="onCancelled"
    />
    <purchase-plan-delete-confirmation
        ref="deleteConfirmation"
        @deleted="onDeleted"
    />
    <purchase-plan-load-error-dialog
        ref="purchasePlanLoadErrorDialog"
    />
  </Layout>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import BaseModelIndex from "../models/index-v3";
import ModelIndex from "@/components/models/index-v2";
import TableModelButtonGroup from "./index/table-model-button-group.vue";
import ModelFilter from "./filter";
import PurchasePlanApproveConfirmation from "@/components/modals/purchase-plan-approve-confirmation.vue";
import PurchasePlanRejectConfirmation from "@/components/modals/purchase-plan-reject-confirmation.vue";
import PurchasePlanBulkActionSuccess from "@/components/modals/purchase-plan-bulk-action-success.vue";
import PurchasePlanBulkActionPartialSuccess from "@/components/modals/purchase-plan-bulk-action-partial-success.vue";
import PurchasePlanDuplicateConfirmation from "@/components/modals/purchase-plan-duplicate-confirmation.vue";
import PurchasePlanCancelConfirmation from "@/components/modals/purchase-plan-cancel-confirmation.vue";
import PurchasePlanDeleteConfirmation from "@/components/modals/purchase-plan-delete-confirmation.vue";
import { amountScaleFormatter } from "@/helpers/ui/formatters";
import StatusWidget from "@/components/widgets/statuses/status";
import StatusBadge from "@/components/badges/status-badge.vue";
import { serialize } from "object-to-formdata";
import Swal from "sweetalert2";
import purchasePlanLoadError from "@/components/mixins/purchase-plan-load-error";

export default {
  extends: BaseModelIndex,
  mixins: [purchasePlanLoadError],
  components: {
    TableModelButtonGroup,
    ModelIndex,
    ModelFilter,
    // Used inside the column template string rendered by the table component.
    // eslint-disable-next-line vue/no-unused-components
    StatusBadge,
    PurchasePlanApproveConfirmation,
    PurchasePlanRejectConfirmation,
    PurchasePlanBulkActionSuccess,
    PurchasePlanBulkActionPartialSuccess,
    PurchasePlanDuplicateConfirmation,
    PurchasePlanCancelConfirmation,
    PurchasePlanDeleteConfirmation,
  },
  page: {
    title: "Purchase Plans",
  },
  props: {
    // this.lodash.startCase(this.$t('purchase_plans.plural')); }
    cardTitle: { default() { return null; } },
    resourceRoute: { default: 'purchase_plans' },
    modelVariable: { default: 'purchase_plan' },
    denyCreate: { type: Boolean, default() { return !this.$auth.hasPermissionTo('purchase_plans.create'); } },
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('purchase_plans.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('purchase_plans.plural')),
          href: '/purchase_plans',
          active: true,
        },
      ],
      sortBy: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').shift()) || 'created_at',
      sortDesc: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').pop() === 'desc') || true,
      searchInput: this.$route.query.search || '',
      filterColumns: {
        submitted_at__between: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("purchase_plans.submitted_at")),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t("purchase_plans.submitted_at")),
          operator: "between",
          input_component: "datepicker-range"
        },
        partner_id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("purchase_plans.partner")),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t("purchase_plans.partner")),
          operator: "in",
          input_component: "supplier-multiselect-ajax",
          params: { sort: 'name' }
        },
        processing_id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("purchase_plans.processing")),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t("purchase_plans.processing")),
          operator: "in",
          input_component: "factory-multiselect-ajax"
        },
        status: {
          type: String,
          label: this.lodash.startCase(this.$t("purchase_plans.approval_status")),
          placeholder: "Pilih Status",
          input_component: "purchase-plan-status-select"
        },
        has_purchase_order: {
          type: String,
          label: this.lodash.startCase(this.$t("purchase_plans.purchase_order_status")),
          placeholder: this.$t("purchase_plans.has_purchase_order_options.all"),
          input_component: "purchase-plan-has-purchase-order-select"
        }
      },
      mode: ['simple', 'advanced'].includes(this.$route.query.mode) ? this.$route.query.mode : 'simple',
      selectedPurchasePlanIds: [],
      bulkApproveLoading: false,
      bulkRejectLoading: false,
      allowedActions: [],
    };
  },
  watch: {
    search(value) {
      this.searchInput = value;
    },
    mode(value) {
      this.queryUpdate({ mode: value });
    },
  },
  computed: {
    hasSelectedPurchasePlans() {
      return this.selectedPurchasePlanIds.length > 0;
    },
    isAnyBulkActionLoading() {
      return this.bulkApproveLoading || this.bulkRejectLoading;
    },
    totalSelectablePlansCount() {
      return (this.models || []).filter(model => this.canBulkSelect(model)).length;
    },
    columns() {
      const modes = {
        simple: [
          'id',
          'sales_plan_id',
          'submitted_at',
          'product.name',
          'partner.name',
          'processing.name',
          'limit',
          'status',
        ],
        advanced: [
          'id',
          'sales_plan_id',
          'submitted_at',
          'product.name',
          'partner.name',
          'processing.name',
          'estimated_amount',
          'realized_amount',
          'estimated_size',
          'estimated_quantity',
          'status',
        ],
      }

      return {
        purchase_plan: [
          {
            key: "bulk_select",
            label: "",
            sortable: false,
            class: "text-center",
            thStyle: {width: "1%"},
            tdClass: "align-middle text-center",
            component: {
              props: ["item"],
              methods: {
                onToggle(checked) {
                  this.$emit("toggle-selection", {
                    item: this.item,
                    checked
                  });
                }
              },
              template: `
                <b-form-checkbox
                    v-if="item._canBulkSelect"
                    :checked="item._selected"
                    @change="onToggle"
                    :aria-label="'Select purchase plan ' + item.id"
                />
              `
            },
            componentListeners: {
              "toggle-selection": payload => this.handlePurchasePlanSelection(payload)
            }
          },
          { key: 'index', label: 'ID', sortable: false, style: { width: '24px' } },
          {
            key: 'id',
            label: this.$t('ID'),
            sortable: true,
            thStyle: { minWidth: '90px' },
          },
          {
            key: 'sales_plan_id',
            label: this.$t('purchase_plans.sales_plan_id'),
            sortable: true,
            thStyle: { minWidth: '140px' },
            component: {
              props: ['item'],
              template: '<router-link v-if="item.sales_plan" :to="`/sales_plans/${item.sales_plan.id}`">{{ `${item.sales_plan.id}: ${item.sales_plan.type_name}` }}</router-link><span v-else>-</span>'
            }
          },
          {
            key: 'submitted_at',
            label: this.lodash.upperFirst(this.$t('purchase_plans.submitted_at')),
            sortable: true,
            thStyle: { minWidth: '160px' },
            formatter: (value) => value ? this.$moment(value).format('DD MMM YYYY') : '-',
          },
          {
            key: 'product.name',
            label: this.lodash.upperFirst(this.$t('purchase_plans.product')),
            sortable: false,
            thStyle: { minWidth: '140px' },
            formatter: (_, __, item) => {
              let productName = item.product?.name || item.product_name || '-'
              if(item.payment_type === 'down_payment_80') {
                productName += ' 80%'
              }
              return productName;
            },
          },
          {
            key: 'partner.name',
            label: this.lodash.upperFirst(this.$t('purchase_plans.partner')),
            sortable: false,
            thStyle: { minWidth: '180px' },
            formatter: (_, __, item) => item.partner?.name || item.partner_name || '-',
          },
          {
            key: 'processing.name',
            label: this.lodash.upperFirst(this.$t('purchase_plans.processing')),
            sortable: false,
            thStyle: { minWidth: '180px' },
            formatter: (_, __, item) => item.processing?.name || item.processing_name || '-',
          },
          {
            key: 'estimated_amount',
            label: this.$t('purchase_plans.estimated_amount_table'),
            sortable: true,
            thStyle: { minWidth: '170px' },
            formatter: (value) => this.$numeral(Number(value || 0)).format('$ 0,0.[000]'),
          },
          {
            key: 'realized_amount',
            label: this.$t('purchase_plans.realized_amount'),
            sortable: true,
            thStyle: { minWidth: '150px' },
            formatter: (value) => this.$numeral(Number(value || 0)).format('$ 0,0.[000]'),
          },
          {
            key: 'estimated_size',
            label: this.$t('purchase_plans.estimated_size'),
            sortable: false,
            thStyle: { minWidth: '160px' },
            formatter: (_, __, item) => {
              const start = item.estimated_size_start;
              const end = item.estimated_size_end;
              if (start === null || start === undefined || end === null || end === undefined) return '-';
              return `${this.$numeral(start).format('0,0.[000]')} - ${this.$numeral(end).format('0,0.[000]')}`;
            },
          },
          {
            key: 'estimated_quantity',
            label: this.$t('purchase_plans.estimated_quantity_table'),
            sortable: true,
            thStyle: { minWidth: '170px' },
            formatter: (value) => this.$numeral(Number(value || 0)).format('0,0.[000]'),
          },
          {
            key: 'limit',
            label: this.lodash.upperFirst(this.$t('purchase_plans.limit') || 'Limit'),
            sortable: false,
            thStyle: { minWidth: '160px' },
            component: {
              props: ['item'],
              template: `
                <div>
                  <b-badge v-if="item._limitBadge" :variant="item._limitBadge.variant">
                    {{ item._limitBadge.label }}
                  </b-badge>
                  <span v-else>-</span>
                </div>
              `
            }
          },
          {
            key: 'status',
            label: 'Status',
            sortable: true,
            thStyle: { minWidth: '120px' },
            component: {
              props: ['item'],
              template: `
                <status-badge
                    v-if="item.status"
                    entity="purchase_plan"
                    type="status"
                    :status="item.status"
                ></status-badge>
                <span v-else>-</span>
              `
            },
          },
          { key: 'action', label: this.$t('Action'), class: 'text-center', style: { minWidth: '110px', width: '110px' } },
        ].map((field) => ({ ...field, tdClass: 'align-middle' })).filter((field => modes[this.mode].includes(field.key) || field.key === 'bulk_select' || field.key === 'action')),
      };
    },
  },
  methods: {
    routeQueryChanged(...args) {
      // Restore mode from query params before delegating to the base implementation.
      const modeFromQuery = this.$route.query.mode;
      if (['simple', 'advanced'].includes(modeFromQuery)) {
        this.mode = modeFromQuery;
      }
      return BaseModelIndex.methods.routeQueryChanged.call(this, ...args);
    },
    getModelName(value) {
      return `#${value.id}`;
    },
    getLimitBadge(model) {
      const limitGroup = model?.processing?.odoo_res_partner?.odoo_obligor_limit?.odoo_obligor_limit_group ?? null;
      if (!limitGroup || limitGroup.limit_amount === null || limitGroup.limit_amount === undefined) {
        return null;
      }
      const usedAmountRatio = Number(limitGroup.used_amount_ratio ?? 0);
      const percentage = usedAmountRatio * 100;
      if (percentage <= 50) {
        return { label: this.$t('purchase_plans.limit_status.safe'), variant: 'success' };
      } else if (percentage <= 80) {
        return { label: this.$t('purchase_plans.limit_status.warning'), variant: 'warning' };
      } else if (percentage <= 100) {
        return { label: this.$t('purchase_plans.limit_status.danger'), variant: 'danger' };
      } else {
        return { label: this.$t('purchase_plans.limit_status.overlimit'), variant: 'dark' };
      }
    },
    onSearchInput(value) {
      this.searchInput = value;
      this.search = value;
    },
    delete(value) {
      return this.$axios.delete(`/v1/purchase_plans/${value.id}`);
    },
    fetchModels(page = 1) {
      return this.$axios.get('/v1/purchase_plans', {
        params: {
          page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          with: 'product,partner,processing.odoo_res_partner.odoo_obligor_limit.odoo_obligor_limit_group,supervisor,sales_plan.product',
          ...this.filterParams,
        },
      }).then((response) => {
        const { data: { data, meta } } = response;
        const currentPageIds = data.map(model => this.getModelKey(model));
        const currentPageSelectableIds = new Set(data.filter(model => this.canBulkSelect(model)).map(model => this.getModelKey(model)));

        this.selectedPurchasePlanIds = this.selectedPurchasePlanIds.filter(id => {
          return !currentPageIds.includes(id) || currentPageSelectableIds.has(id);
        });

        this.allowedActions = Array.isArray(meta?.allowed_actions) ? meta.allowed_actions : [];
        this.stats = [
          {
            title: this.lodash.startCase(this.$t("purchase_plans.widgets.estimated_amount_title")),
            value: amountScaleFormatter(meta?.total_estimated_amount ?? 0),
            valueTitle: amountScaleFormatter(meta?.total_estimated_amount ?? 0),
            wrapperClass: "col-12 col-md-6 col-xl-3",
            component: StatusWidget,
            icon: "bx bx-line-chart",
          },
          {
            title: this.lodash.startCase(this.$t("purchase_plans.widgets.realized_amount_title")),
            value: amountScaleFormatter(meta?.total_realized_amount ?? 0),
            valueTitle: amountScaleFormatter(meta?.total_realized_amount ?? 0),
            wrapperClass: "col-12 col-md-6 col-xl-3",
            component: StatusWidget,
            icon: "bx bx-wallet",
          },
        ];
        this.$set(this, "models", data.map(model => ({
          ...model,
          _selected: this.selectedPurchasePlanIds.includes(this.getModelKey(model)),
          _canBulkSelect: this.canBulkSelect(model),
          _denyEdit: !this.hasAllowedAction(model, ["edit", "update"]),
          _denyDelete: !this.hasAllowedAction(model, ["delete", "destroy"]),
          _denyCancel: !this.hasAllowedAction(model, ["cancel"]),
          _limitBadge: this.getLimitBadge(model),
        })));

        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        return response;
      }).catch((error) => this.handlePurchasePlanLoadError(error));
    },
    canBulkSelect(model) {
      return this.hasAllowedAction(model, ["approve", "reject"]);
    },
    selectAllSelectablePlans() {
      const selectable = (this.models || []).filter(model => this.canBulkSelect(model));
      selectable.forEach(model => {
        model._selected = true;
        const id = this.getModelKey(model);
        if (!this.selectedPurchasePlanIds.includes(id)) {
          this.selectedPurchasePlanIds.push(id);
        }
      });
    },
    handlePurchasePlanSelection({item, checked}) {
      const id = this.getModelKey(item);
      item._selected = checked;
      if (checked) {
        if (!this.selectedPurchasePlanIds.includes(id)) {
          this.selectedPurchasePlanIds = [...this.selectedPurchasePlanIds, id];
        }
        return;
      }
      this.selectedPurchasePlanIds = this.selectedPurchasePlanIds.filter(selectedId => selectedId !== id);
    },
    clearSelectedPurchasePlans() {
      this.selectedPurchasePlanIds = [];
      (this.models || []).forEach(model => {
        model._selected = false;
      });
    },
    buildActionPayload({ids = [], description = null, reason = null, file = null} = {}) {
      const payload = {};

      if (Array.isArray(ids) && ids.length > 0) {
        payload.ids = ids;
        payload.purchase_plan_ids = ids;
      }

      const resolvedText = [description, reason].find((value) => {
        return value !== null && value !== undefined && `${value}`.trim() !== '';
      });

      if (resolvedText !== undefined) {
        const text = `${resolvedText}`.trim();
        payload.description = text;
        payload.reason = text;
      }

      if (file) {
        payload.file = file;
      }

      if (Object.keys(payload).length === 0) {
        return {};
      }

      return serialize(payload, {indices: true, booleansAsIntegers: true});
    },
    getAllowedActions(model) {
      return Array.isArray(model?.allowed_actions) ? model.allowed_actions : [];
    },
    hasAllowedAction(model, actions) {
      const allowedActions = this.getAllowedActions(model);
      return actions.some(action => allowedActions.includes(action));
    },
    extractBulkActionSummary(response, totalSelected) {
      const data = response?.data?.data ?? {};
      const successItems = Array.isArray(data.success_items) ? data.success_items : [];
      const failedItems = Array.isArray(data.failed_items) ? data.failed_items : [];
      const successIds = this.normalizeBulkActionIds(successItems);
      const failedIds = this.normalizeBulkActionIds(failedItems);
      const successCount = this.extractBulkActionCount(data, [
        "success_count",
      ]) ?? (successIds.length > 0 ? successIds.length : null);
      const failedCount = this.extractBulkActionCount(data, [
        "failed_count",
      ]) ?? (failedIds.length > 0 ? failedIds.length : null);

      return {
        data,
        totalSelected,
        successItems,
        failedItems,
        successIds,
        failedIds,
        successCount: successCount ?? 0,
        failedCount: failedCount ?? 0,
        message: data.message || data?.data?.message || null,
      };
    },
    isBulkActionFullySuccessful(summary) {
      const total = Number(summary?.totalSelected || 0);
      const successCount = Number(summary?.successCount || 0);
      const failedCount = Number(summary?.failedCount || 0);
      const successIdsCount = Array.isArray(summary?.successIds) ? summary.successIds.length : 0;

      if (total <= 0 || failedCount > 0) {
        return false;
      }

      if (successCount >= total || successIdsCount >= total) {
        return true;
      }

      return successCount === 0 && successIdsCount === 0;
    },
    showBulkActionSuccessModal(action, summary) {
      const total = Number(summary?.totalSelected || 0) || this.selectedPurchasePlanIds.length;
      const successCount = Number(summary?.successCount || 0);
      const resolvedCount = successCount > 0 ? successCount : total;
      const modalRef = this.$refs["purchase-plan-bulk-action-success"];
      const key = action === "approve"
          ? "purchase_plans.modal_messages.bulk_approve_success_title"
          : "purchase_plans.modal_messages.bulk_reject_success_title";
      const title = this.$t(key);
      const msgKey = action === "approve"
          ? "purchase_plans.modal_messages.bulk_approve_success_message"
          : "purchase_plans.modal_messages.bulk_reject_success_message";
      const message = this.$t(msgKey, {count: resolvedCount});

      if (!modalRef) {
        return Swal.fire({
          title: title + "!",
          text: message,
          type: "success",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        });
      }

      return modalRef.show({
        title: title + "!",
        message,
      });
    },
    showBulkActionPartialSuccessModal(action, summary) {
      const total = Number(summary?.totalSelected || 0) || this.selectedPurchasePlanIds.length;
      const successCount = Number(summary?.successCount || 0);
      const modalRef = this.$refs["purchase-plan-bulk-action-partial-success"];
      
      const titleKey = successCount <= 0
          ? (action === "approve" ? "purchase_plans.modal_messages.bulk_approve_failed_title" : "purchase_plans.modal_messages.bulk_reject_failed_title")
          : (action === "approve" ? "purchase_plans.modal_messages.bulk_approve_partial_success_title" : "purchase_plans.modal_messages.bulk_reject_partial_success_title");
      const title = this.$t(titleKey);

      const msgKey = action === "approve"
          ? "purchase_plans.modal_messages.bulk_approve_partial_success_message"
          : "purchase_plans.modal_messages.bulk_reject_partial_success_message";
      const message = this.$t(msgKey, {
        success_count: successCount,
        total,
      });

      const items = this.buildBulkActionResultItems(summary, action);

      if (!modalRef) {
        const safeHtmlItems = items.map((item) => {
          const safeLabel = this.lodash.escape(item.label || `ID ${item.id}`);
          const safeReason = item.reason ? this.lodash.escape(item.reason) : "";
          return `<div>[${this.lodash.escape(item.status)}] ${safeLabel}${safeReason ? ` - ${safeReason}` : ""}</div>`;
        }).join("");

        return Swal.fire({
          title: title + "!",
          html: `
            <div>${message}</div>
            ${items.length ? `<div class="mt-3">${safeHtmlItems}</div>` : ""}
          `,
          type: "warning",
          confirmButtonClass: "btn btn-warning btn-fill",
          buttonsStyling: false
        });
      }

      return modalRef.show({
        title: title + "!",
        message,
        items,
      });
    },
    handleBulkActionResultModalHidden() {
      this.clearSelectedPurchasePlans();
      this.$router.go(0);
    },
    async executeBulkPurchasePlanAction(action, payload = {}) {
      const ids = [...this.selectedPurchasePlanIds];
      const endpoint = action === "approve"
          ? "/v1/purchase_plans/bulk-approve"
          : "/v1/purchase_plans/bulk-reject";
      const response = await this.$axios.post(
          endpoint,
          this.buildActionPayload({
            ...payload,
            ids,
          })
      );
      const summary = this.extractBulkActionSummary(response, ids.length);

      await this.bulkActionSummaryAlert(action, summary);
    },
    bulkActionSummaryAlert(action, summary) {
      if (this.isBulkActionFullySuccessful(summary)) {
        return this.showBulkActionSuccessModal(action, summary);
      }

      return this.showBulkActionPartialSuccessModal(action, summary);
    },
    openBulkActionModal(action) {
      const total = this.selectedPurchasePlanIds.length;
      const modalRef = this.$refs[action === "approve" ? "purchase-plan-approve-confirmation" : "purchase-plan-reject-confirmation"];
      if (!modalRef) {
        return Promise.resolve(false);
      }

      const titleKey = action === "approve"
          ? "purchase_plans.modal_messages.bulk_confirm_approve_title"
          : "purchase_plans.modal_messages.bulk_confirm_reject_title";
      const msgKey = action === "approve"
          ? "purchase_plans.modal_messages.bulk_confirm_approve_description"
          : "purchase_plans.modal_messages.bulk_confirm_reject_description";

      return modalRef.show({
        title: this.$t(titleKey, {count: total}),
        message: this.$t(msgKey, {count: total}),
      }).then((result) => {
        if (!result) {
          return null;
        }

        const loadingKey = action === "approve" ? "bulkApproveLoading" : "bulkRejectLoading";
        this.$set(this, loadingKey, true);
        return this.executeBulkPurchasePlanAction(action, result)
            .catch((error) => {
              this.failedAlert(error);
            })
            .finally(() => {
              this.$set(this, loadingKey, false);
            });
      });
    },
    handleBulkApprove() {
      if (!this.hasSelectedPurchasePlans) return;
      return this.openBulkActionModal("approve");
    },
    handleBulkReject() {
      if (!this.hasSelectedPurchasePlans) return;
      return this.openBulkActionModal("reject");
    },
    handleDuplicate(value) {
      return this.$refs.duplicateConfirmation.show(value);
    },
    handleCancel(value) {
      return this.$refs.cancelConfirmation.show(value);
    },
    onCancelled() {
      return this.$refs.table.$refs.table.refresh();
    },
    handleDelete(value) {
      return this.$refs.deleteConfirmation.show(value);
    },
    onDeleted(deletedKey) {
      this.selectedPurchasePlanIds = this.selectedPurchasePlanIds.filter(id => id !== deletedKey);
      this.$refs.table.$refs.table.refresh();
      return this.deleteSuccessAlert(`#${deletedKey}`);
    },
    normalizeBulkActionIds(value) {
      if (!Array.isArray(value)) {
        return [];
      }

      return value
          .map((item) => {
            if (item && typeof item === "object") {
              return this.getModelKey(item);
            }

            return item;
          })
          .filter((item) => item !== null && item !== undefined && item !== "");
    },
    extractBulkActionCount(data, keys = []) {
      for (const key of keys) {
        const rawValue = this.lodash.get(data, key);
        const count = Number(rawValue);
        if (Number.isFinite(count)) {
          return count;
        }
      }

      return null;
    },
    normalizeBulkActionText(value) {
      if (Array.isArray(value)) {
        return value
            .map((entry) => this.normalizeBulkActionText(entry))
            .filter((entry) => entry !== null && entry !== undefined && `${entry}`.trim() !== "")
            .join(", ");
      }

      if (value && typeof value === "object") {
        return this.normalizeBulkActionText(
            value.message
            ?? value.errors
        );
      }

      if (value === null || value === undefined) {
        return null;
      }

      const text = `${value}`.trim();
      return text.length > 0 ? text : null;
    },
    extractBulkActionItemReason(item, reasonMap = null, fallbackReason = null) {
      const id = this.getBulkActionItemId(item);
      const mappedReason = reasonMap && typeof reasonMap === "object"
          ? reasonMap[id] ?? reasonMap[String(id)]
          : null;

      return this.normalizeBulkActionText(
          (item && typeof item === "object")
              ? item.message
              ?? item.errors
              : null
      ) || this.normalizeBulkActionText(mappedReason) || this.normalizeBulkActionText(fallbackReason);
    },
    normalizeBulkActionDisplayItems(items, status, reasonMap = null, fallbackReason = null) {
      if (!Array.isArray(items)) {
        return [];
      }

      return items
          .map((item) => {
            const id = this.getBulkActionItemId(item);
            if (id === null || id === undefined || id === "") {
              return null;
            }

            return {
              id,
              status,
              label: this.getBulkActionItemLabel(item),
              reason: this.extractBulkActionItemReason(item, reasonMap, fallbackReason),
            };
          })
          .filter(Boolean);
    },
    buildBulkActionResultItems(summary, action) {
      const fallbackMessage = summary?.message || null;
      const failedReasonMap = this.lodash.get(summary?.data, "errors") || null;
      const successItems = this.normalizeBulkActionDisplayItems(
          summary?.successItems || summary?.data?.success_items,
          "success"
      );
      const failedItems = this.normalizeBulkActionDisplayItems(
          summary?.failedItems || summary?.data?.failed_items,
          "warning",
          failedReasonMap,
          fallbackMessage
      );

      return [...successItems, ...failedItems].map((item, index) => ({
        ...item,
        key: `${item.status}-${item.id}-${index}`,
        action,
      }));
    },
    getBulkActionItemId(item) {
      if (item && typeof item === "object") {
        return this.getModelKey(item) ?? item.id ?? null;
      }

      return item ?? null;
    },
    getBulkActionItemLabel(item) {
      const id = this.getBulkActionItemId(item);
      const model = this.models.find((model) => this.getModelKey(model) === id);
      if (!model) {
        return `ID ${id}`;
      }

      return this.purchasePlanDisplayLabel(model);
    },
    purchasePlanDisplayLabel(purchasePlan) {
      if (!purchasePlan || typeof purchasePlan !== "object") {
        return "-";
      }

      const id = purchasePlan.id ?? "-";
      const productName = purchasePlan?.product?.name ?? purchasePlan?.product_name ?? "-";

      return `${id}: ${productName}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/design/app";
@import "../../../design/custom/components/status-badge";


::v-deep {
  .w-1 {
    width: 1% !important;
  }

  .w-50px {
    width: 50px !important;
  }

  .w-70px {
    width: 70px !important;
  }

  .w-75px {
    width: 75px !important;
  }

  .w-80px {
    width: 80px !important;
  }

  .w-150px {
    width: 150px !important;
  }

  .w-200px {
    width: 200px !important;
  }

  .p-12px {
    padding: 12px !important;
  }

  .card {
    .card-sub-title {
      font: 400 14px/16px Lato, sans-serif;

      &.text-muted {
        color: #6C7589 !important;
      }
    }

    .customer-metric-bold {
      font: 800 36px Lato, sans-serif;
    }
  }


  .child-detail-table {
    margin: 0;
    border-width: 0 !important;
    border-radius: 0 !important;
  }

  .mixed-limit-table {
    margin: 0;
    border-width: 0 !important;
    border-radius: 0 !important;
  }

  .mixed-limit-table thead th,
  .mixed-limit-table thead th:first-child,
  .mixed-limit-table thead>tr>[aria-sort] {
    background-color: $neutral-subdued !important;
  }

  .mixed-limit-table .cursor-pointer {
    cursor: pointer;
  }

  .mixed-limit-table .mixed-limit-child-row td {
    font-size: 12px;
    background: white !important;
  }

  .mixed-limit-table .mixed-limit-child-cell {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }

  .mixed-limit-table .mixed-limit-group-row td {
    background: #f5f6f7;
  }

  .child-detail-table thead th,
  .child-detail-table tbody th {
    background: $neutral-subdued;
    border-color: transparent;
  }

  .child-detail-table tbody tr td,
  .child-detail-table tbody tr td>* {
    font-size: 12px;
    background: white !important;
  }

  .jds-table {
    .table-responsive {
      overflow-x: auto;
    }
  }

  .table-model {
    @extend .jds-table;
    border: none !important;
    box-shadow: none !important;

    table {
      @extend .table-zebra;
    }

    .table-responsive {
      border: none !important;
      box-shadow: none !important;
    }
  }

  .purchase-plan-table {
    .row {
      &> .col-md-6:first-child {
        max-width: 100% !important;
        flex: 0 0 100% !important;
      }
      background: #FAFAFA;
    }
  }

  .table.b-table {
    tbody {
      tr.b-table-details {
        td:first-child {
          padding: 0 !important;
        }
      }
    }
  }

  .page-content {
    background: #EEF3F7 !important;
    font-family: Lato;
    color: #161B4D;
  }

  .dataTables_paginate.paging_simple_numbers {
    margin-top: 0.5rem;
  }

  .dataTables_length select {
    height: 39px;
    // background: #F4F7FA;
    border: 1px solid #dbdce2;
    border-radius: 8px;
    font-weight: 700;
    font-size: 16px;
  }

  .dataTables_filter {
    position: relative;

    input {
      height: 39px;
      padding-left: 34px;
      background: #f4f7fa;
      border: 1px solid #dbdce2;
      border-radius: 8px;
    }

    input::placeholder {
      font-weight: 500;
      font-size: 14px;
      color: #7e889d;
    }

    .prefix-icon {
      position: absolute;
      top: 10px;
      left: 18px;
    }
  }

  .page-item.active {
    button {
      border-radius: 4px !important;
    }
  }

  .mini-stats-wid {
    .media-body {
      p {
        font-weight: 500;
        font-size: 14px;
        color: #6C7589 !important;
      }

      h4 {
        font-weight: 800;
        font-size: 18px;
        color: #161B4D;
      }
    }
  }

  .custom-checkbox .custom-control-label::before {
    border-radius: 0.25rem;
  }
}
</style>